import { Injectable } from '@angular/core';
import { typeWrapper } from '@cf/core';
import { Store, StoreConfig } from '@datorama/akita';
import {
  DateFormatEnum,
  FirstDayOfWeekEnum,
  RegistrationSourceEnum,
  TimeFormatEnum,
  TimezoneEnum,
} from '../enums';
import { LanguageEnum } from '../helpers/language.helper';
import { IAccount } from '../interfaces';

const createInitialState = (): IAccount => ({
  id: typeWrapper<number>(undefined),
  name: typeWrapper<string>(undefined),
  email: typeWrapper<string>(undefined),
  new_email: typeWrapper<string>(undefined),
  username: typeWrapper<string>(undefined),
  language: typeWrapper<LanguageEnum>(undefined),
  locale: typeWrapper<string>(undefined),
  show_hints: typeWrapper<boolean>(undefined),
  timezone: typeWrapper<TimezoneEnum>(undefined),
  ignored_timezone: typeWrapper<TimezoneEnum>(undefined),
  date_format: typeWrapper<DateFormatEnum>(undefined),
  time_format: typeWrapper<TimeFormatEnum>(undefined),
  first_day_of_week: typeWrapper<FirstDayOfWeekEnum>(undefined),
  has_password: typeWrapper<boolean>(undefined),
  registration_source: typeWrapper<RegistrationSourceEnum>(undefined),
  is_email_changeable: typeWrapper<boolean>(undefined),
  show_connect_calendar: typeWrapper<boolean>(undefined),
  profile_picture: typeWrapper<string>(undefined),
  has_any_connected_calendar: typeWrapper<boolean>(undefined),
  has_any_unusable_calendar: typeWrapper<boolean>(undefined),
  connected_contacts: typeWrapper<boolean>(undefined),
  is_superuser: typeWrapper<boolean>(undefined),
  default_schedule_booking_calendar_email: typeWrapper<string>(undefined),
  showCalendarAlert: typeWrapper<boolean>(undefined),
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'account', resettable: true })
export class AccountStore extends Store<IAccount> {
  constructor() {
    super(createInitialState());
  }
}
